import React from 'react';
import type { Key } from '@heroui/react';

/** Adapts the page size to the footer Select's keys, as the branch picker does. */
export const useProductTableFooter = (
    pageSize: number,
    onPageSizeChange: (size: number) => void,
) => {
    const onSelectionChange = React.useCallback(
        (key: Key | null) => {
            if (key) {
                onPageSizeChange(Number(key));
            }
        },
        [onPageSizeChange],
    );
    return { selectedKey: String(pageSize), onSelectionChange };
};
